<template>
  <Teleport to="body">
    <div v-if="open" class="modal-backdrop" @click="$emit('close')">
      <div
        ref="overlayRoot"
        :class="['modal', size === 'lg' ? 'lg' : '']"
        role="dialog"
        aria-modal="true"
        :aria-label="title || 'Dialog'"
        tabindex="-1"
        @click.stop
      >
        <div class="modal-head">
          <h2>{{ title }}</h2>
          <button @click="$emit('close')" aria-label="Close">
            <IconX :size="18" />
          </button>
        </div>
        <div class="modal-body">
          <slot />
        </div>
        <div v-if="$slots.footer" class="modal-foot">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import { IconX } from '@/components/icons'
import overlayMixin from '@/composables/overlayMixin'

export default {
  name: 'AppModal',
  components: { IconX },
  mixins: [overlayMixin],
  props: {
    open: { type: Boolean, default: false },
    title: { type: String, default: '' },
    size: { type: String, default: '' }
  },
  emits: ['close']
}
</script>
